export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/download-icon.5e378a04.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};